import * as React from 'react';
import injectSheet from 'react-jss';
import { Button } from 'antd';
import ContainerIcon from 'src/components/common/icons/ContainerIcon';

const styles = theme => ({
    selected: {
        borderColor: theme.colors.primary,
        color: theme.colors.primary,
    },
    unselected: {
        borderColor: '#D9D9D9',
        color: '#D9D9D9',
    }
});

const SEContainer = ({
    classes,
    container,
    selected = true,
    onClick = e => {},
    nonClickable = false,
  }) => {

    return <Button
      className={`${selected ? classes.selected : classes.unselected}`}
      style={{
        width: 'fit-content',
        background: 'transparent',
        pointerEvents: nonClickable ? 'none' : 'auto',
      }}
      onClick={onClick}>
      <>
        <ContainerIcon color={`${selected ? '#1890FF' : '#D9D9D9'}`}/>
        <span style={{ marginLeft: 5 }}>{container}</span>
      </>
    </Button>;
  };

  export default React.memo(
    injectSheet(styles)(SEContainer),
  );